'use strict';

var App = require('app');
var AppState = require('app_state');
var BreadcrumbView = require('components/profile/views/device_report_breadcrumbs_view');
var Consts = require('consts');
var CommonViews = require('components/common/views');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var RankingDeviceView = require('components/devices/views/tools/ranking/ranking_device_view');

var urlParams = ['rule', 'priority', 'sortCol', 'sortDesc', 'page', 'filter'];

var RankingView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/tools/ranking/ranking'),
    lastFilter: '',

    ui: {
        ddlPeriod: '#rf-period',
        ddlPriority: '#rf-priority',
        ddlCategory: '#rf-category',
        ddlRule: '#rf-rule',
    },

    regions: {
        rankingFilter: '#ranking-filter',
        rankingResult: '#ranking-result',
    },

    events: {
        'change select.js-ranking-filter': function () {
            this.reload(true);
        },
        'hide.bs.select select.js-ranking-filter-select': function () {
            this.reload(true);
        },
        'click .js-tab-btn-filter': function () {
            this.showFilter();
        },
        'click .js-edit-filter': function () {
            this.showFilter();
        },
        'click .js-reset-filter': function () {
            this.filterData.filter = {};
            this.render();
            this.reload();
        },
        'click #js-global-refresh': function () {
            if (this.resultView) {
                // update current view
                this.resultView.refreshTable();
            } else {
                // "hard" page reload
                Backbone.history.loadUrl(Backbone.history.fragment);
            }
        },
    },

    showFilter: function () {
        var self = this;
        this.options.controller.showFilterDialog(this.filterData && this.filterData.filter, function (filter) {
            App.hideModal();
            self.filterData.filter = filter;
            self.render();
            self.reload();
        });
    },

    filterData: {
        period: 30,
    },

    reload: function (fromForm) {
        var self = this;

        // filter data from controls
        if (fromForm) {
            this.filterData.period = parseInt(this.ui.ddlPeriod.val());
            this.filterData.rule = this.ui.ddlRule.val();
            this.filterData.category = this.ui.ddlCategory.val();
            this.filterData.priority = parseInt(this.ui.ddlPriority.val());
        }

        if (!this.filterData.sortCol) {
            this.filterData.sortCol = 'ranking1';
            this.filterData.sortDesc = true;
        }

        this.filterData.offset = (this.filterData.page - 1) * this.filterData.limit;
        var filterStr = JSON.stringify(this.filterData);
        if (filterStr != this.lastFilter) {
            this.filterData.offset = 0;
            this.filterData.page = 0;
            this.lastFilter = filterStr;
        }

        this.updateURL();

        // execute filter
        App.requestDone('ranking:devices', this.filterData, function (result, err) {
            if (
                App.errIfUndefined(
                    result,
                    I18N.TR('Die Anlagenanalyse konnte nicht geladen werden.'),
                    'rankingResult',
                    self
                )
            )
                return;

            if (result.get('count') == 0) {
                var options = {
                    title: I18N.TR('Keine Geräte gefunden'),
                    text: I18N.TR('Es wurden keine Geräte gefunden, die Ihrer Filtereinstellung entsprechen.'),
                };

                if (!_.isEmpty(self.filterData.filter)) {
                    options.action_label = I18N.TR('Filter zurücksetzen');
                    options.action_cb = function () {
                        self.filterData.filter = {};
                        self.render();
                        self.reload();
                    };
                }

                self.showChildView('rankingResult', new CommonViews.Message(options));
                return;
            }

            self.resultView = new RankingDeviceView({
                data: result,
                filterData: self.filterData,
            });

            self.showChildView('rankingResult', self.resultView);
        });
    },

    updateURL: function () {
        var self = this;
        var parts = {};
        _.each(urlParams, function (key) {
            var value = self.filterData[key];
            if (value) {
                switch (key) {
                    case 'filter':
                        parts[key] = JSON.stringify(value);
                        break;
                    default:
                        parts[key] = value;
                        break;
                }
            }
        });

        this.lastURL = AppState.setURLParameter(parts, 'replace');
    },

    initialize: function (options) {
        var self = this;
        this.controller = this.options.controller;

        this.filterData.onUpdate = function () {
            self.updateURL();
            if (self.resultView) {
                self.resultView.lastURL = self.lastURL;
            }
        };
        this.filterData.rules = options.rules;
        this.filterData.categories = _.sortBy(
            Misc.selectWhere(
                _.pairs(Consts.CategoryData),
                function (item) {
                    return item[1].inVirtualDevice !== false && (AppState.user.get('is_admin') || !item[1].adminOnly);
                },
                function (item) {
                    return {
                        name: item[1].name,
                        value: item[1].category,
                        icon: item[1].icon,
                    };
                }
            ),
            'name'
        );

        // from URL to filterData
        var params = AppState.getURLParameter(urlParams, true);
        _.each(params, function (value, key) {
            switch (key) {
                case 'filter':
                    self.filterData[key] = value && JSON.parse(value);
                    break;
                case 'rule':
                    self.filterData[key] = value && value.split ? value.split(',') : [];
                    break;
                case 'category':
                    self.filterData[key] = value;
                    break;
                case 'sortDesc':
                    self.filterData[key] = value == 'true';
                    break;
                case 'sortCol':
                    self.filterData[key] = value;
                    break;
                default:
                    self.filterData[key] = parseInt(value);
            }
        });
        this.filterData.limit = AppState.getItemsPerPage();
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this);

        data.rankingFilter = Misc.cloneAsJSON(this.filterData);
        _.each(data.rankingFilter.rules, function (e) {
            e.name = I18N.TR(e.name);
        });
        data.rankingFilter.rules = _.sortBy(data.rankingFilter.rules, function (e) {
            return e.name;
        });

        if (this.filterData.filter) {
            data.filter = this.filterData.filter;
        }
        data.showFilter = data.filter && Misc.hasFilterSet(data.filter);

        return data;
    },

    onAttach: function () {
        var self = this;
        Misc.initSelectPicker();
        setTimeout(function () {
            self.reload(false);
        });
    },

    onRender: function () {
        Misc.initSelectPicker();
    },
});

module.exports = RankingView;
